<template>
  <div>
    <VCard>
      <div class="pa-4">
        <AppInput
          v-model="filters.applicationId"
          label="查詢人員的代辦工作"
          type="picker"
          item-title="label"
          item-value="value"
          placeholder="請選擇人員"
          :picker="duUserPicker"
          :disabled="false"
          clearable
          @update:model-value="updateApplicationId"
        />
      </div>
      <div class="d-flex justify-end pa-4">
        <AppInput
          v-model="transferUser"
          type="picker"
          item-title="label"
          item-value="value"
          placeholder="請選擇轉派人員"
          :picker="duUserPicker"
          :disabled="false"
          clearable
          class="mr-2"
          @update:model-value="updateApplicationId"
        />
        <v-btn color="primary" @click="handleTransfer">轉派</v-btn>
      </div>
      <v-data-table 
      v-model="selected"
      :headers="headers" 
      :items="data" 
      no-data-text="查無資料"
      show-select
      item-value="ezoFormId"
      :loading="isLoading">
      <template #item.status="{ item }">
        <v-chip
          :color="statusColorLeaveChangeApplication[item.status as keyof typeof statusColorLeaveChangeApplication]??'secondary'"
          class="rounded-pill"
          variant="tonal"
          size="small"
        >
          {{ statusCNameLeaveChangeApplication[item.status as keyof typeof statusCNameLeaveChangeApplication]??item.status }}
        </v-chip>
      </template>
      </v-data-table>
    </VCard>
    <snackbar-component :snackbar="snackbar" v-model:show="snackbar.show" />
    <!-- <OutingApplicationList :isCenter="false" /> -->
  </div>
</template>

<script setup lang="ts">
// import { outingApplicationQuery } from './api/athApiUrl';
// import OutingApplicationList from './outingApplicationQu ery/OutingApplicationList.vue';
// import {statusCNameLeaveChangeApplication,statusColorLeaveChangeApplication} from './statusConfig/status-leave-chenge-application';

definePage({
  meta: {
    action: 'manage',
    subject: 'REASSIGNAPPLICATION',
  },
})

const filters = reactive({
  applicationId: '',
  sortOrder:null,
  orderByCol:null,
  page:1,
  itemsPerPage:10,
})
const isLoading = ref(false);

const selected = ref([]);

const totalItems = ref(0);
const data = ref([]);
const transferUser = ref('');

const snackbar = ref({
  show: false,
  text: '',
  color: 'success',
  timeout: 3000
})

const showSnackbar = (color: string, text: string, timeout: number) => {
  snackbar.value.show = false
  let data = $showSnackbar(color, text, timeout)
  Object.assign(snackbar.value, data)
}

const headers = [
  { title: '單號', key: 'priKey', align: 'start', sortable: true },
  { title: '類型', key: 'outingCancellationMark', sortable: true ,value:(val)=>{return val=='+'?'請假':'銷假'}},
  { title: '申請人', key: 'applicantId', sortable: true },
  { title: '單據狀態', key: 'status', sortable: true },
  { title: '外出起', key: 'startDateTime', sortable: true },
  { title: '外出迄', key: 'endDateTime', sortable: true },
];




const updateApplicationId = async (value: string) => {
  if(isEmpty(value)) {
    showSnackbar('error', '請選擇人員', -1)
    return
  }
  isLoading.value = true;

  // $popSwal('success', '查詢成功', '查詢')
  isLoading.value = false;
  // try {
  //   let url = outingApplicationQuery.todoWorks
  //   const response = await $api(`${url}/${toCode(filters.applicationId)}`, {
  //     method: 'GET',
  //   });
  //   // Assume standard ApiResponse<Page<tbath21VO>> structure
  //   data.value = response?.data ?? [];
  //   totalItems.value = response?.data?.length ?? 0;
  //   showSnackbar('success', `查詢 ${toText(filters.applicationId)} 待辦工作成功`, 3000);
  //   selected.value = [];
  // } catch (err: any) {
  //   let errorMessage = err?.data?.message || err.message || '搜尋失敗，請稍後再試！';
  //   showSnackbar('error', '查詢失敗:'+ errorMessage,3000);
  //   data.value = [];
  //   totalItems.value = 0;
  // } finally {
  //   isLoading.value = false;
  // }
}

const handleTransfer = async () => {
  if(isEmpty(transferUser.value)) {
    showSnackbar('error', '請選擇轉派人員', -1)
    return
  }
  if(isEmpty(selected.value)) {
    showSnackbar('error', '請選擇要轉派的工作', -1)
    return
  }
  $swal({
    icon: 'warning',
    title: `確定要轉派 ${selected.value.length}筆 給人員 ${toText(transferUser.value)} 嗎？`,
    showCancelButton: true,
    confirmButtonText: '我要轉派',
    cancelButtonText: '取消',
    focusCancel: true,
  }).then(async(result) => {
    if(result.isConfirmed) {
      isLoading.value = true;
      try {
        const res = await $api(outingApplicationQuery.todoWorkPassTo, {
          method: 'POST',
          body: {
            formIds: selected.value,
            userNo: toCode(transferUser.value)
          }
        });
        showSnackbar('success', '轉派成功', 3000);
        updateApplicationId(filters.applicationId);
      }catch(err: any) {
        let errorMessage = err?.data?.error?.details || err?.error?.details ||err?.data?.message || err.message || '轉派失敗，請稍後再試！';
        showSnackbar('error', '轉派失敗:'+ errorMessage,3000);
      } finally {
        isLoading.value = false;
      }
    }
  })
}



</script>

<style>

</style>